import React, { useState, useEffect } from 'react'
import { getNotesData, addData, updateData } from '../../lib/pagenotes'
import { TextEditor } from '../Common/TextEditor'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'
import ScheduleStatusModal from '../ScheduleManagement/ScheduleStatusModal'
import parse from 'html-react-parser'

const PageNotes = ({ type, studentId, instructorId, pageName, showScheduleButton = true }) => {
	pageName = 'Task'

	const [studentNote, setStudentNote] = useState('')
	const [instructorNote, setInstructorNote] = useState('')
	const [status, setStatus] = useState('')
	const [recId, setRecId] = useState()
	const [loading, setLoading] = useState(false)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)
	const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false)
	const [isDarkMode, setIsDarkMode] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const handleSubmitInstructor = async (e) => {
		e.preventDefault()
		setLoading(true)

		try {
			if (status === 'Add') {
				await addData({
					page: pageName,
					studentId: studentId,
					studentNote: studentNote,
					instructorId: instructorId,
					instructorNote: instructorNote
				})
				setStatus('Update')
			} else {
				await updateData({
					id: recId,
					page: pageName,
					studentId: studentId,
					studentNote: studentNote,
					instructorId: instructorId,
					instructorNote: instructorNote
				})
			}
			showToastMessage('Update successful!')
		} catch (error) {
			console.error('Error saving notes:', error)
		} finally {
			setLoading(false)
		}
	}

	const recordCheck = async () => {
		try {
			const sdata = await getNotesData(studentId, instructorId, pageName)

			if (sdata.length === 0) {
				setStatus('Add')
			} else {
				setStatus('Update')
				setRecId(sdata[0].id)
				getNotes()
			}
		} catch (error) {
			console.error('Error checking records:', error)
		}
	}

	const getNotes = async () => {
		try {
			const sdata = await getNotesData(studentId, instructorId, pageName)
			if (sdata && sdata.length > 0) {
				setStudentNote(sdata[0].studentNote || '')
				setInstructorNote(sdata[0].instructorNote || '')
				setRecId(sdata[0].id)
			}
		} catch (error) {
			console.error('Error fetching notes:', error)
		}
	}

	useEffect(() => {
		if (studentId) {
			recordCheck()
			setShowToast(false)
		}
	}, [studentId, instructorId, pageName])

	useEffect(() => {
		const checkDarkMode = () => {
			setIsDarkMode(document.body.classList.contains('dark-only'))
		}
		checkDarkMode()
		const observer = new MutationObserver(checkDarkMode)
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
		return () => observer.disconnect()
	}, [])

	return (
		<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<div className="card-header border-bottom d-flex justify-content-between align-items-center">
				<div className="d-flex align-items-center">
					<button
						type="button"
						className="btn btn-link p-0 me-2"
						data-bs-toggle="collapse"
						data-bs-target="#collapseNotes"
						aria-expanded="true"
						aria-controls="collapseNotes"
					>
						<i className="fa fa-chevron-down"></i>
					</button>
					<h5 className="mb-0 d-inline-block">Note</h5>
				</div>
				{type === 'Instructor' && showScheduleButton && (
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => setIsScheduleModalOpen(true)}
					>
						<i className="fa fa-calendar me-2"></i>
						Schedule
					</button>
				)}
			</div>
			<div className="collapse show" id="collapseNotes">
				<div className="card-body">
					{type === 'Instructor' ? (
						<form method="post" onSubmit={handleSubmitInstructor}>
							<div className="mb-3">
								<TextEditor value={instructorNote} setValue={setInstructorNote} />
							</div>
							<div className="d-flex justify-content-end">
								<button type="submit" className="btn btn-primary" disabled={loading}>
									<i className="fa fa-save me-2"></i>
									{loading ? 'Updating...' : 'Update Note'}
								</button>
							</div>
						</form>
					) : (
						<div className="p-3 rounded border">
							<h6 className="fw-bold mb-2">Instructor Notes:</h6>
							<div className="richtext-html-content">
								{instructorNote ? parse(instructorNote) : 'No notes available'}
							</div>
						</div>
					)}
				</div>
			</div>
			{type === 'Instructor' && showScheduleButton && studentId && instructorId && (
				<ScheduleStatusModal
					isOpen={isScheduleModalOpen}
					toggle={() => setIsScheduleModalOpen((prev) => !prev)}
					instructorId={instructorId}
					studentId={studentId}
					isDarkMode={isDarkMode}
				/>
			)}
		</div>
	)
}

export { PageNotes }
